import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-chevron-icon/jb-chevron-icon.scss?inline
var jb_chevron_icon_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: inline-block;
  height: var(--icon-size, 18px);
  width: var(--icon-size, 18px);
}

svg {
  fill: rgb(var(--rgb-primary, 20, 30, 85));
  transition: transform 0.3s, opacity 0.3s;
}
svg:hover:not(.disabled) {
  cursor: pointer;
  transform: translateX(3px);
}

.left {
  transform: scale(-1, 1);
}
.left:hover:not(.disabled) {
  transform: scale(-1, 1) translateX(3px);
}

.down {
  transform: rotate(90deg);
}
.down:hover:not(.disabled) {
  transform: rotate(90deg) translateX(3px);
}

.up {
  transform: rotate(-90deg);
}
.up:hover:not(.disabled) {
  transform: rotate(-90deg) translateX(3px);
}

.disabled {
  opacity: 0.2;
}`;

// src/components/icons/jb-chevron-icon/jb-chevron-icon.ts
var JbChevronIcon = class extends r2 {
  constructor() {
    super(...arguments);
    this.direction = "right";
    this.disabled = false;
  }
  render() {
    return ke`
      <svg
        class="${this.direction || "right"} ${this.disabled ? "disabled" : ""}"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.3013 8.41088C12.6273 8.73626 12.6272 9.26376 12.3013 9.58911L6.82477 15.056C6.49884 15.3813 5.9704 15.3814 5.64445 15.056C5.31849 14.7306 5.31852 14.2031 5.64445 13.8777L10.5308 9L5.64445 4.12225C5.31849 3.79688 5.31852 3.26937 5.64445 2.94402C5.97038 2.61867 6.49881 2.61864 6.82477 2.94402L12.3013 8.41088Z"
        />
      </svg>
    `;
  }
};
JbChevronIcon.styles = r(jb_chevron_icon_default);
__decorateClass([
  n()
], JbChevronIcon.prototype, "direction", 2);
__decorateClass([
  n({ type: Boolean })
], JbChevronIcon.prototype, "disabled", 2);
JbChevronIcon = __decorateClass([
  customElement("jb-chevron-icon")
], JbChevronIcon);

export {
  JbChevronIcon
};
